<template>
  <div class="container-fluid new_Header">
    <div class="row nav_Breadcrumb">
      <div class="col">
        <nav>
          <ol class="breadcrumb">
            <li class="breadcrumb-item mx-1"><router-link  to="/">{{$t('createfinance.breadcrumb_1')}}</router-link></li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item  almarai-bold" aria-current="page">
              <span class="mx-1">{{$t('createfinance.breadcrumb_2')}}</span>
            </li>
            <i  v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
            <i  v-else class="fa-solid fa-chevron-right pt-1"></i>
            <li class="breadcrumb-item almarai-bold" aria-current="page">
              <span class="mx-1 almarai-bold">{{$t('createfinance.title_1')}}</span>
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <div class="container pt-3">
    <div class="row financeRequest justify-content-center">
      <div class="col">
        <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
        <div class="row justify-content-center finance" v-if="setp == 1">
          <div class="col-12 col-md-8">
            <div class="card">
              <div class="card-body">
                <form action="">
                  <div class="row">
                    <div class="col position-R">
                      <label for="" class="almarai-regular fonttext-14 gray-color">
                        {{$t('createfinance.title_2')}}
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="fullName" class="form-control  input-style" id="name"
                        maxlength="50" @keypress="charsOnly"
                      >
                      <i class="fa-solid fa-id-card finance-Icons"></i>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.fullName.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col position-R">
                      <label for="" class="almarai-regular fonttext-14 gray-color">
                        {{$t('createfinance.title_3')}}
                        <span class="stars">*</span>
                      </label>
                      <input type="text" v-model="mobile" class="form-control input-style" id="number"
                        maxlength="10" @input="mobile = mobile.replace(/[^0-9]/g, '')"
                      >
                      <i class="fa-solid fa-mobile-screen-button finance-Icons"></i>
                    </div>
                    <div class="error-feedback red-color fonttext-14" v-if="V$.mobile.$error">
                      {{ validateMessage }}
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col position-R">
                      <label class="almarai-regular fonttext-14 gray-color" for="">
                        {{$t('createfinance.title_4')}}
                      </label>
                      <input type="text" v-model="salary" class="form-control input-style"
                        maxlength="10" @input="salaryFormat"
                      >
                      <i class="fa-solid fa-dollar-sign finance-Icons"></i>
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col position-R">
                      <label class="almarai-regular fonttext-14 gray-color" for="">
                        {{$t('createfinance.title_5')}}
                      </label>
                      <input type="text" v-model="amount" class="form-control input-style"
                        maxlength="10" @input="formatNumber"
                      >
                      <i class="fa-solid fa-money-bill-wave finance-Icons"></i>
                    </div>
                  </div>
                  <div class="row pt-3">
                    <div class="col">
                      <label for="" class="almarai-regular fonttext-14 gray-color">{{$t('createfinance.title_6')}}</label>
                      <textarea v-model="obligations" class="form-control br-radius-16 border-EEE" rows="4"></textarea>
                    </div>
                  </div>
                  <div class="row pt-5 justify-content-center">
                    <div class="text-center" v-if="isLoading"> <loader /> </div>
                    <div v-else class="col-11 col-md-5 mouse-hand" @click.prevent="financeRequest">
                      <div class="text-center btn-green">{{$t('createfinance.title_7')}}</div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-3 justify-content-center" v-if="setp == 2">
          <div class="col text-center">
            <div><img src="/assets/images/tick-circle.png" alt=""></div>
            <h4>{{$t('createfinance.title_8')}}</h4>
            <!-- <p>{{$t('createfinance.title_11')}} <br> {{$t('createfinance.title_10')}} <br> {{$t('createfinance.title_9')}}</p> -->
            <p>{{$t('createfinance.finace_P')}}</p>
            <div class="row pb-4 justify-content-center">
            <div class="col-11 col-md-6 text-center" @click.prevent="goAndClose">
              <div class="btn-black">{{$t('createfinance.title_12')}}</div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Button trigger modal -->
    <!-- <button type="button" id="financePoup" class="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#exampleModal">
    </button> -->

    <!-- Modal -->
    <div class="modal bg-modal hidden-fileds" id="exampleModal" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <!-- <div class="modal-header">
            <h1 class="modal-title fs-5" id="exampleModalLabel">Modal title</h1>
          </div> -->
          <!-- <button type="button" class="btn-close p-2 me-2 mt-2" data-bs-dismiss="modal" aria-label="Close"></button> -->
          <div class="modal-body text-center">
            <div><img src="/assets/images/tick-circle.png" alt=""></div>
            <h4>{{$t('createfinance.title_8')}}</h4>
            <!-- <p>{{$t('createfinance.title_11')}} <br> {{$t('createfinance.title_10')}} <br> {{$t('createfinance.title_9')}}</p> -->
            <p>{{$t('createfinance.finace_P')}}</p>
          </div>
          <div class="row pb-4 justify-content-center">
            <div class="col-8 text-center" @click.prevent="goAndClose">
              <div class="btn-black">{{$t('createfinance.title_12')}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
export default {
  name: "createfinance",
  setup () {
    return { V$: useVuelidate() }
  },
  data(){
    return{
      propertyId: this.$route.params.key,
      isLoading: false,
      hasError: false,
      message: "",
      errorNumber: null,
      fullName: "",
      mobile: "",
      salary: null,
      amount: null,
      obligations: "",
      userLang: 'ar',
      validateMessage: this.$t('validateMessage'),
      setp: 1,
    }
  },
  validations(){
    return {
      fullName: {required},
      mobile: {required},
    }
  },
  methods:{

    async financeRequest(){
      this.hasError =false;
      const valid = await this.V$.$validate();
      if(!valid){
        window.scroll(0,0);
        return false;
      }
      if(this.mobile.trim().length != 10 || !this.mobile.startsWith('05')){
        this.message = this.$t('incorrectMobile');
        this.hasError = true;
        window.scrollTo({top:0, behavior:'smooth'});
        return false;
      }
      this.isLoading = true;
      this.$http.post("/api/financeRequests/create",{
        propertyId: parseInt(this.propertyId),
        fullName: this.fullName,
        mobile: this.mobile,
        amount: parseInt(this.amount),
        salary: parseInt(this.salary),
        obligations: this.obligations,
      }).then(res => {
        // console.log(res);
        // document.getElementById('exampleModal').style.display= 'block';
        this.setp = 2;
        // this.fullName = "",
        // this.mobile = "",
        // this.amount = null,
        // this.salary = null,
        // this.obligations = "",
        this.isLoading = false;
        window.scroll(0,0);
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      });
    },

    charsOnly(e) {
      // keep only Arabic letters, Latin letters, and spaces
      // requires modern JS regex support for Unicode property escapes
      const char = e.key;
      const allowed = /^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFA-Za-z\s]$/;

      if (!allowed.test(char)) {
        e.preventDefault(); // block the input
      }
    },
    goAndClose() {
      // const modal = bootstrap.Modal.getInstance(
      //   document.getElementById('exampleModal')
      // );
      // modal.hide();  
      document.getElementById('exampleModal').style.display = 'none';   
      this.$router.push({ name: 'home' });
    },

    formatNumber() {
      // امسح أي حروف غير أرقام
      let raw = this.amount.replace(/,/g, "").replace(/\D/g, "");

      // لو فاضي — رجّعه
      if (!raw) {
        this.amount = "";
        return;
      }
      // إضافة الفواصل كل 3 أرقام
      this.amount = Number(raw).toLocaleString("en-US");
    },
    salaryFormat() {
      // امسح أي حروف غير أرقام
      let sal = this.salary.replace(/,/g, "").replace(/\D/g, "");

      // لو فاضي — رجّعه
      if (!sal) {
        this.salary = "";
        return;
      }
      // إضافة الفواصل كل 3 أرقام
      this.salary = Number(sal).toLocaleString("en-US");
    },
  },
  created(){
    window.scroll(0,0);
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  }

}
</script>